import { useEffect } from "react";
const PIXEL_ID = "1555763442913803";
const META_SCRIPT_URL = "https://connect.facebook.net/en_US/fbevents.js";
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  loaded?: boolean;
  queue?: unknown[][];
  version?: string;
};
type MetaWindow = Window & {
  _fbq?: MetaPixelFunction;
  fbq?: MetaPixelFunction;
};
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }
    const metaWindow = window as MetaWindow;
    let fbq = metaWindow.fbq;
    if (!fbq) {
      const queuedPixel = ((...args: unknown[]) => {
        if (queuedPixel.callMethod) {
          queuedPixel.callMethod(...args);
          return;
        }
        queuedPixel.queue?.push(args);
      }) as MetaPixelFunction;
      queuedPixel.loaded = true;
      queuedPixel.version = "2.0";
      queuedPixel.queue = [];
      metaWindow.fbq = queuedPixel;
      metaWindow._fbq = queuedPixel;
      fbq = queuedPixel;

      // En algunos iframes no existe ningún <script> inicial para usar como ancla.
      // Se añade directamente al <head> y se evita cargarlo más de una vez.
      const alreadyLoaded = document.querySelector(`script[src="${META_SCRIPT_URL}"]`);
      const scriptTarget = document.head || document.body || document.documentElement;
      if (!alreadyLoaded && scriptTarget) {
        const script = document.createElement("script");
        script.async = true;
        script.src = META_SCRIPT_URL;
        scriptTarget.appendChild(script);
      }
      fbq("init", PIXEL_ID);
    }
    fbq("track", "PageView");
  }, []);
  return <noscript data-id="element-159" data-mp="1w6dshtwdx8y1">
      <img height="1" width="1" style={{
      display: "none"
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-160" data-mp="1w6nmrtogq29j" />
    </noscript>;
}